import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const partnersSlice = createSlice({
  name: "partners",
  initialState,
  reducers: {
    partnersLoading(state) {
      state.loading = true;
      state.error = null;
    },
    partnersError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setPartnersList(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const { partnersLoading, partnersError, setPartnersList } =
  partnersSlice.actions;

export default partnersSlice.reducer;
